import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        // `justify-start`/`justify-end` on the TRACK park the thumb at the right
        // end of the track, instead of translating it by a fixed distance.
        // Two bugs this avoids:
        //   1. `translate-x-4` is a hard-coded 16px, but callers override the
        //      track width (the keep-awake pill uses `w-7`), so the thumb
        //      overshot the track and spilled onto the label next to it.
        //   2. translate-x is physical, so in RTL it pushed the thumb the wrong
        //      way entirely — out the far side of the track.
        // justify-content is both width-exact and direction-aware, so the thumb
        // lands correctly for any track size in both LTR and RTL.
        "peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-slate-400/50 inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-slate-300 dark:border-slate-600 shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:justify-end data-[state=unchecked]:justify-start",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "bg-white pointer-events-none block size-4 rounded-full ring-0 shadow-lg border border-slate-200 dark:border-slate-500"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
